<div *ngIf="panel">
  <span class="panel-summ-selectedPanel-span">Selected Panel: </span>
  <span class="panel-summ-panelName-span">{{panel?.Name}}</span>
  <span *ngIf="panel.Name !== panel.Description" class="panel-summ-panelName-span"> - {{panel?.Description}} </span>
  <span class="panel-summ-selectedPanel-span"> ({{respondentStatement()}})</span>
</div>
